import { useEffect } from 'react';
import { useLogin } from '../Contexts/AuthProvider/AuthProvider';
import AuthForm from './AuthForm/AuthForm';
import { isTokenExpired } from '../Helpers/jwt.utils';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Componente para proteger rutas que requieren autenticación
 * - Verifica si existe un token
 * - Verifica si el token no ha expirado
 * - Si el token es inválido, muestra el formulario de login
 * - Ejecuta logout automático si detecta token expirado
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, logout, isAuthenticated } = useLogin();

  // Verificar y hacer logout si el token está expirado
  useEffect(() => {
    if (user?.token && isTokenExpired(user.token)) {
      console.log('[ProtectedRoute] Token expirado, ejecutando logout...');
      logout();
    }
  }, [user?.token, logout]);

  // Verificar autenticación y validez del token
  const isValidSession = isAuthenticated && user?.token && !isTokenExpired(user.token);

  // Si no hay sesión válida, mostrar el formulario de login a pantalla completa
  if (!isValidSession) {
    return <AuthForm />;
  }

  return <>{children}</>;
}
